/** Can be use to synchronize an asynchronous operation to prevent parallel execution. */
var Lock = /** @class */ (function () {
    function Lock(pMaxConcurrentTasks) {
        var _this = this;
        if (pMaxConcurrentTasks === void 0) { pMaxConcurrentTasks = 1; }
        this.onUnlock = function (pAsync) {
            if (pAsync === void 0) { pAsync = false; }
            _this.mCurrentRunningTasks--;
            if (pAsync) {
                setTimeout(function () {
                    _this.resolveNext();
                });
            }
            else {
                _this.resolveNext();
            }
        };
        this.mMaxConcurrentTasks = pMaxConcurrentTasks;
        this.mCurrentRunningTasks = 0;
        this.mPromiseQueue = new Array();
        this.mLockContext = {
            unlock: this.onUnlock
        };
        this.mWaitPromise = null;
        this.mWaitPromiseResolve = null;
    }
    Object.defineProperty(Lock.prototype, "isLocked", {
        get: function () {
            return (this.mCurrentRunningTasks >= this.mMaxConcurrentTasks);
        },
        enumerable: false,
        configurable: true
    });
    Lock.prototype.acquireLock = function () {
        var _this = this;
        var tPromise = new Promise(function (resolve, reject) {
            _this.mPromiseQueue.push(resolve);
        });
        this.resolveNext();
        return (tPromise);
    };
    Lock.prototype.waitWhileLocked = function () {
        var _this = this;
        if (this.isLocked) {
            if (this.mWaitPromise == null) {
                this.mWaitPromise = new Promise(function (resolve, reject) {
                    _this.mWaitPromiseResolve = resolve;
                });
            }
            return (this.mWaitPromise);
        }
        else {
            return (Promise.resolve());
        }
    };
    Lock.prototype.resolveNext = function () {
        if (!this.isLocked) {
            this.resolveWaitPromise();
            var tResolve = this.mPromiseQueue.shift();
            if (tResolve !== undefined) {
                this.mCurrentRunningTasks++;
                tResolve(this.mLockContext);
            }
        }
    };
    Lock.prototype.resolveWaitPromise = function () {
        if (this.mWaitPromiseResolve != null) {
            this.mWaitPromise = null;
            this.mWaitPromiseResolve();
            this.mWaitPromiseResolve = null;
        }
    };
    return Lock;
}());
export { Lock };
export default Lock;
